module.exports = __webpack_public_path__ + "img/Cedar & Elm 9600x540.02b351b3.png";